// src/pages/TermsAndConditionsPage.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { url } from "../constants/url";
import { useNavigate } from "react-router-dom";

const TermsAndConditionsPage = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    axios
      .get(`${url}/api/public/terms`)
      .then((res) => {
        setContent(res.data.terms.content);
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          localStorage.clear();
          navigate("/login");
        } else {
          console.error("Error loading terms:", err);
          setError("Failed to load Terms & Conditions.");
        }
      })
      .finally(() => setLoading(false));
  }, []);
  

  if (loading) {
    return (
      <div className="max-w-4xl mx-auto p-6 mt-10">
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton key={i} height={20} style={{ marginBottom: "0.75rem" }} />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-4xl mx-auto p-6 mt-10 text-red-500">{error}</div>
    );
  }

  return (
    <div className="p-6 bg-white rounded-3xl shadow-md max-w-4xl mx-auto mt-10">
      <h1 className="text-3xl font-semibold mb-6 text-[#AF9C80]">
        Terms and Conditions
      </h1>
      <div
        className="prose prose-lg text-gray-700 leading-relaxed"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

export default TermsAndConditionsPage;
